// import React from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import { FaArrowRight } from "react-icons/fa";
// import "../styles/ThankYouPage.css";

// export default function ThankYouPage() {
//   return (
//     <div className="thankyou-container">
//       {/* Floating gradient blobs */}
//       <motion.div
//         className="blob blob-left"
//         animate={{ x: [0, 40, -40, 0], y: [0, 30, -20, 0] }}
//         transition={{ repeat: Infinity, duration: 10, ease: "easeInOut" }}
//       />
//       <motion.div
//         className="blob blob-right"
//         animate={{ x: [0, -40, 40, 0], y: [0, -20, 20, 0] }}
//         transition={{ repeat: Infinity, duration: 12, ease: "easeInOut" }}
//       />

//       {/* Success Ring */}
//       <motion.div
//         initial={{ scale: 0, rotate: 180, opacity: 0 }}
//         animate={{ scale: 1, rotate: 360, opacity: 1 }}
//         transition={{ duration: 1.2, type: "spring", bounce: 0.4 }}
//         className="success-ring-wrapper"
//       >
//         <motion.div
//           className="success-ring"
//           animate={{
//             boxShadow: [
//               "0 0 20px #00e676",
//               "0 0 40px #00e676",
//               "0 0 20px #00e676",
//             ],
//           }}
//           transition={{ repeat: Infinity, duration: 2 }}
//         >
//           <motion.svg
//             width="60"
//             height="60"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="#00e676"
//             strokeWidth="2.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             initial={{ pathLength: 0 }}
//             animate={{ pathLength: 1 }}
//             transition={{ delay: 0.5, duration: 1 }}
//           >
//             <motion.path d="M20 6L9 17l-5-5" />
//           </motion.svg>
//         </motion.div>
//       </motion.div>

//       {/* Text Content */}
//       <motion.h1
//         className="thankyou-title"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 1, duration: 0.8 }}
//       >
//         Order Placed Successful
//       </motion.h1>

//       <motion.p
//         className="thankyou-text"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 1.2, duration: 0.8 }}
//       >
//         Thank you for shopping with us. Sit back and relax — we’ve got this.
//       </motion.p>

//       {/* Button */}
//       <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 1.4, duration: 0.8 }}
//       >
//         <Link to="/" className="thankyou-button" onClick={() => window.scrollTo(0,0)}>
//           Continue Shopping <FaArrowRight />
//         </Link>
//       </motion.div>
//     </div>
//   );
// }


// 


// import React, { useEffect, useState, useRef } from "react";
// import { useSearchParams, Link } from "react-router-dom";
// import { FaArrowRight } from "react-icons/fa";

// const ThankYouPage = ({ cartItems, addresses, billingIndex, appliedDeliveryCharge }) => {
//   const [searchParams] = useSearchParams();
//   const paymentStatus = searchParams.get("status");
//   const orderId = searchParams.get("order_id");
//   const trackingId = searchParams.get("tracking_id");
//   const productdetailsJSON = searchParams.get("productdetails") || "[]";

//   const [orderApiStatus, setOrderApiStatus] = useState("idle");
//   const hasCalledApi = useRef(false);

//   // Decode productdetails from JSON
//   const productdetails = JSON.parse(productdetailsJSON);

//   useEffect(() => {
//     if (paymentStatus === "Success" && !hasCalledApi.current) {
//       handleDatabasePlacement();
//     } else if (paymentStatus !== "Success" && paymentStatus !== null) {
//       setOrderApiStatus("error");
//     }
//   }, [paymentStatus]);

//   const handleDatabasePlacement = async () => {
//     if (!productdetails.length) {
//       setOrderApiStatus("error");
//       return;
//     }

//     setOrderApiStatus("processing");
//     hasCalledApi.current = true;

//     try {
//       // Example billing info from URL
//       const billing = {
//         userId: "guest", // If you don't have a userId in URL, use 'guest' or map it
//         name: searchParams.get("billing_name"),
//         email: searchParams.get("billing_email"),
//         phone: searchParams.get("billing_tel"),
//         address: searchParams.get("billing_address"),
//         type: "Home",
//         landmark: "",
//         pincode: searchParams.get("billing_zip"),
//         city: searchParams.get("billing_city"),
//         district: searchParams.get("billing_district"),
//         state: searchParams.get("billing_state"),
//       };

//       const istTime = new Date();

//       // Prepare payload for place_order.php
//       const payload = {
//         user_id: billing.userId,
//         order_date: istTime.toISOString().slice(0, 19).replace("T", " "),
//         order_status: "Accepted",
//         payment_status: "Paid",
//         gateway_order_id: orderId,
//         user_name: billing.name,
//         user_mail: billing.email,
//         user_mobile: billing.phone,
//         user_address: billing.address,
//         address_type: billing.type,
//         user_landmark: billing.landmark,
//         user_pincode: billing.pincode,
//         user_city: billing.city,
//         user_district: billing.district,
//         user_state: billing.state,
//         delivery_charge: appliedDeliveryCharge || 0,
//         order_total: Number(searchParams.get("total")) || 0,
//         items: productdetails.map((item) => ({
//           product_id: item.product_id,
//           mp_id: item.main_category_id || "0",
//           sp_id: item.sub_category_id || "0",
//           type: item.type, // or pass from item.type
//           title: item.product_name,
//           image: item.image,
//           quantity: Number(item.qty),
//           price: Number(item.amount),
//           subtotal: Number(item.amount) * Number(item.qty),
//           total: Number(item.totalamount),
//           code: item.product_code,
//         })),
//       };

//       // Call place_order.php to insert DB record
//       const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}place_order.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const data = await res.json();

//       if (data?.head?.code === 200) {
//         setOrderApiStatus("success");
//         // Optional: send email notification
//         fetch(`${process.env.REACT_APP_API_BASE_URL}mail_order.php`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ user_id: billing.userId }),
//         }).catch(() => {});
//         localStorage.removeItem("cart");
//         window.dispatchEvent(new Event("cartUpdated"));
//       } else {
//         setOrderApiStatus("error");
//       }
//     } catch (err) {
//       console.error("Database placement error:", err);
//       setOrderApiStatus("error");
//     }
//   };

//   return (
//     <div>
//       {orderApiStatus === "processing" && <h2>Verifying Payment & Saving Order...</h2>}
//       {orderApiStatus === "success" && (
//         <div>
//           <h1>Order Successful!</h1>
//           <p>Order ID: {orderId}</p>
//           <p>Total Paid: ₹{searchParams.get("total")}</p>
//           <Link to="/">Continue Shopping <FaArrowRight /></Link>
//         </div>
//       )}
//       {orderApiStatus === "error" && <h1>Payment or Order Failed</h1>}
//     </div>
//   );
// };

// export default ThankYouPage;


import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";
import "../styles/ThankYouPage.css";



const ThankYouPage = ({ appliedDeliveryCharge }) => {
  const savedPayload = JSON.parse(
  localStorage.getItem("pendingOrderPayload")
);
console.log("=====savedPayload========",savedPayload);
  const [searchParams] = useSearchParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  // Payment and order details from URL
  const paymentStatus = searchParams.get("status");
  const orderId = searchParams.get("order_id");
  const trackingId = searchParams.get("tracking_id");
  const note = searchParams.get("note") || "";
  const subtotal = Number(searchParams.get("subtotal")) || 0;
  const sgst = Number(searchParams.get("sgst")) || 0;
  const cgst = Number(searchParams.get("cgst")) || 0;
  const total = Number(searchParams.get("total")) || 0;
  const productdetailsJSON = searchParams.get("productdetails") || "[]";

  const [orderApiStatus, setOrderApiStatus] = useState("idle"); // idle | processing | success | error
  const hasCalledApi = useRef(false);

  // Decode product details from JSON
  const productdetails = JSON.parse(productdetailsJSON);

  const finalPayload = {
  ...savedPayload,

  // 🔹 payment info from gateway
  payment_status: paymentStatus,
  gateway_order_id: orderId,
  tracking_id: trackingId,

   order_status: paymentStatus === "Success" ? "Accepted" : "Failed",
  updated_at: new Date()
    .toISOString()
    .slice(0, 19)
    .replace("T", " "),
  };

  // Extract billing info from URL
  const billing = {
    userId: searchParams.get("user_id") || "guest",
    name: searchParams.get("billing_name") || "",
    email: searchParams.get("billing_email") || "",
    phone: searchParams.get("billing_tel") || "",
    address: searchParams.get("billing_address") || "",
    type: searchParams.get("billing_type") || "Home",
    landmark: searchParams.get("billing_landmark") || "",
    pincode: searchParams.get("billing_zip") || "",
    city: searchParams.get("billing_city") || "",
    district: searchParams.get("billing_district") || "",
    state: searchParams.get("billing_state") || "",
  };

  useEffect(() => {
    if (paymentStatus === "Success" && !hasCalledApi.current) {
      handleDatabasePlacement();
    } else if (paymentStatus !== "Success" && paymentStatus !== null) {
      setOrderApiStatus("error");
    }
  }, [paymentStatus]);

  const handleDatabasePlacement = async () => {
    console.log("===========line 280 ===========");
    // if (!productdetails.length || !billing.name) {
    //   setOrderApiStatus("error");
    //   return;
    // }

    setOrderApiStatus("processing");
    hasCalledApi.current = true;

    try {
      // const istTime = new Date();

      // const payload = {
      //   user_id: billing.userId,
      //   order_date: istTime.toISOString().slice(0, 19).replace("T", " "),
      //   order_status: "Accepted",
      //   payment_status: "Paid",
      //   gateway_order_id: orderId,
      //   user_name: billing.name,
      //   user_mail: billing.email,
      //   user_mobile: billing.phone,
      //   user_address: billing.address,
      //   address_type: billing.type,
      //   user_landmark: billing.landmark,
      //   user_pincode: billing.pincode,
      //   user_city: billing.city,
      //   user_district: billing.district,
      //   user_state: billing.state,
      //   delivery_charge: appliedDeliveryCharge || 0,
      //   subtotal,
      //   sgst,
      //   cgst,
      //   tax: sgst + cgst,
      //   note,
      //   order_total: total,
      //   items: productdetails.map((item) => ({
      //     product_id: item.product_id,
      //     mp_id: item.main_category_id || "0",
      //     sp_id: item.sub_category_id || "0",
      //     type: item.type,
      //     title: item.product_name,
      //     image: item.image,
      //     quantity: Number(item.qty),
      //     price: Number(item.amount),
      //     subtotal: Number(item.amount) * Number(item.qty),
      //     total: Number(item.totalamount),
      //     code: item.product_code,
      //   })),
      // };
console.log("======payload is ==========",finalPayload);
      const res = await fetch(`${API_BASE_URL}place_order.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(finalPayload),
      });
      const data = await res.json();
console.log("=====data is ====",data);

      if (data?.head?.code === 200) {
        setOrderApiStatus("success");

        // Optional: send email notification
        fetch(`${API_BASE_URL}mail_order.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id: finalPayload.user_id }),
        }).catch(() => {});

        // Clear cart locally
        localStorage.removeItem("cart");
        window.dispatchEvent(new Event("cartUpdated"));
      } else {
        setOrderApiStatus("error");
      }
    } catch (err) {
      console.error("Database placement error:", err);
      setOrderApiStatus("error");
    }
  };
  if (paymentStatus === "Success")
 return (
    <div className="thankyou-container">
      {/* Floating blobs */}
      <motion.div
        className="blob blob-left"
        animate={{ x: [0, 40, -40, 0], y: [0, 30, -20, 0] }}
        transition={{ repeat: Infinity, duration: 10, ease: "easeInOut" }}
      />
      <motion.div
        className="blob blob-right"
        animate={{ x: [0, -40, 40, 0], y: [0, -20, 20, 0] }}
        transition={{ repeat: Infinity, duration: 12, ease: "easeInOut" }}
      />

      {/* Success Ring */}
      <motion.div
        className="success-ring-wrapper"
        initial={{ scale: 0, rotate: 180, opacity: 0 }}
        animate={{ scale: 1, rotate: 360, opacity: 1 }}
        transition={{ duration: 1.2, type: "spring", bounce: 0.4 }}
      >
        <motion.div
          className="success-ring"
          animate={{
            boxShadow: [
              "0 0 20px #00e676",
              "0 0 40px #00e676",
              "0 0 20px #00e676",
            ],
          }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <motion.svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#00e676"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            <motion.path d="M20 6L9 17l-5-5" />
          </motion.svg>
        </motion.div>
      </motion.div>

      {/* Text */}
      <motion.h1
        className="thankyou-title"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.8 }}
      >
        Order Placed Successful
      </motion.h1>

      <motion.p
        className="thankyou-text"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      >
        Thank you for shopping with us. Sit back and relax —
        <br />
        we’ve got this.
      </motion.p>

      {/* Button */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.4, duration: 0.8 }}
      >
        <Link to="/" className="thankyou-button">
          Continue Shopping <FaArrowRight />
        </Link>
      </motion.div>
    </div>
  );

  if (paymentStatus !== "Success")
  return (
    <div className="thankyou-container">
      {/* Floating blobs */}
      <motion.div
        className="blob blob-left"
        animate={{ x: [0, 40, -40, 0], y: [0, 30, -20, 0] }}
        transition={{ repeat: Infinity, duration: 10, ease: "easeInOut" }}
      />
      <motion.div
        className="blob blob-right"
        animate={{ x: [0, -40, 40, 0], y: [0, -20, 20, 0] }}
        transition={{ repeat: Infinity, duration: 12, ease: "easeInOut" }}
      />

      {/* ❌ Error Ring */}
      <motion.div
        className="success-ring-wrapper"
        initial={{ scale: 0, rotate: 180, opacity: 0 }}
        animate={{ scale: 1, rotate: 360, opacity: 1 }}
        transition={{ duration: 1.2, type: "spring", bounce: 0.4 }}
      >
        <motion.div
          className="success-ring"
          style={{ borderColor: "#ff4d4f" }}
          animate={{
            boxShadow: [
              "0 0 20px #ff4d4f",
              "0 0 40px #ff4d4f",
              "0 0 20px #ff4d4f",
            ],
          }}
          transition={{ repeat: Infinity, duration: 2 }}
        >
          <motion.svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ff4d4f"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            {/* Exclamation mark */}
            <motion.path d="M12 5v9" />
            <motion.path d="M12 18h.01" />
          </motion.svg>
        </motion.div>
      </motion.div>

      {/* Text */}
      <motion.h1
        className="thankyou-title"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.8 }}
        style={{ color: "#ff4d4f" }}
      >
        Payment Failed
      </motion.h1>

      <motion.p
        className="thankyou-text"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      >
        We couldn’t process your payment.
        <br />
        Please contact the admin team for assistance.
      </motion.p>

      {/* Button */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.4, duration: 0.8 }}
      >
        <Link to="/" className="thankyou-button" style={{ borderColor: "#ff4d4f", color: "#ff4d4f" }}>
          Back to Home <FaArrowRight />
        </Link>
      </motion.div>
    </div>
  );


};

export default ThankYouPage;
